/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

import { Breadcrumb, Col } from 'antd'
import { map } from 'lodash'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const SearchItem = ({ categoryName, detail, slugs, onClick }) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <Col flex="auto" className="search__item" onClick={onClick}>
      <div className="search__item__header">
        <p>{categoryName}</p>
        <Breadcrumb>
          {map(slugs, (s, key) => (
            <Breadcrumb.Item key={key} id={s}>
              {key === 0 || key === 3 - 1 ? <Link to={`/category/${s}`}>{s}</Link> : s}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
      <div className="search__item__detail_markdown" dangerouslySetInnerHTML={{ __html: detail }} />
    </Col>
  )
}

SearchItem.propTypes = {
  categoryName: PropTypes.string,
  detail: PropTypes.string,
  searchtext: PropTypes.string,
  slugs: PropTypes.array,
  onClick: PropTypes.func,
}

export default SearchItem
